// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"appWrapper--1wH_tXYu","intlSelect":"intlSelect--2an2MIkx"};